import React from 'react';
import '../styles.css';

type WizardShellProps = {
  children: React.ReactNode;
  title?: string;
  /** fill = fixed viewport, no page scroll (internal panes scroll) */
  variant?: 'scroll' | 'fill';
};

/** White content panel matching LMS Create Session (Layout already wraps the route). */
export function WizardShell({ children, title, variant = 'scroll' }: WizardShellProps) {
  const panelClass =
    variant === 'fill'
      ? 'codelive-wizard my-2 me-2 rounded-2 codelive-wizard-panel codelive-wizard-panel--fill'
      : 'codelive-wizard my-2 me-2 rounded-2 codelive-wizard-panel';

  return (
    <div className={panelClass}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            {title ? <h5 className="mb-3">{title}</h5> : null}
            <div className="codelive-wizard-page">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function AppLayout({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={className}>{children}</div>;
}

export function PageMain({
  children,
  className,
  variant = 'scroll',
}: {
  children: React.ReactNode;
  className?: string;
  variant?: 'scroll' | 'fill';
}) {
  return (
    <WizardShell variant={variant}>
      {className ? <div className={className}>{children}</div> : children}
    </WizardShell>
  );
}

export function Header({ title }: { user?: unknown; title?: string }) {
  return title ? <h5 className="mb-2 pt-2">{title}</h5> : null;
}
